document.addEventListener("DOMContentLoaded", function () {
  const modal = document.getElementById("compatibility-modal");
  const backdrop = document.getElementById("compatibility-modal-backdrop");

  const closeModal = () => {
    modal.classList.add("compatibility-modal--hidden");
    backdrop.classList.add("compatibility-modal__backdrop--hidden");
    document.body.style.overflow = "";
  };

  document.querySelectorAll("[data-open-compatibility]").forEach((btn) => {
    btn.addEventListener("click", () => {
      modal.classList.remove("compatibility-modal--hidden");
      backdrop.classList.remove("compatibility-modal__backdrop--hidden");
      document.body.style.overflow = "hidden";
    });
  });

  document.getElementById("close-modal").addEventListener("click", closeModal);
  backdrop.addEventListener("click", closeModal);
  document
    .getElementById("continue-modal")
    .addEventListener("click", closeModal);

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") closeModal();
  });
});
